// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"65a64b0e","82":"d057a90b","94":"7edfeff5","206":"f95d3d4b","215":"4f4341a7","317":"e2d34b6c","391":"721c73ae","419":"46e4abad","565":"e8f9bf53","885":"3a70fe68","933":"78ce315c","946":"ba892fee"}[chunkId] + ".chunk.js";
};